// Roofs
import ic_floor_roof_type_a from './ic_floor_roof_type_a.png';
import ic_floor_roof_type_b from './ic_floor_roof_type_a.png';
import ic_floor_roof_type_c from './ic_floor_roof_type_a.png';
import ic_floor_roof_type_d from './ic_floor_roof_type_a.png';
import ic_floor_roof_type_e from './ic_floor_roof_type_e.png';
import ic_floor_roof_type_f from './ic_floor_roof_type_f.png';
import ic_floor_roof_type_g from './ic_mosquito_type_a.png';
import ic_floor_roof_type_h from './ic_mosquito_type_b.png';
import ic_floor_roof_type_i from './ic_mosquito_type_c.png';
// Floors
import ic_floor_type_a from './ic_floor_type_a.png';
import ic_floor_type_b from './ic_floor_type_b.png';
import ic_floor_type_c from './ic_floor_type_c.png';
import ic_floor_type_d from './ic_floor_type_d.png';
// Basements
import ic_floor_basement_type_a from './ic_floor_basement_type_a.png';
import ic_floor_basement_type_b from './ic_floor_basement_type_b.png';
import ic_floor_basement_type_c from './ic_floor_basement_type_c.png';
import ic_floor_basement_type_d from './ic_floor_basement_type_d.png';
import ic_floor_basement_type_e from './ic_floor_basement_type_e.png';
// Plane
// import ic_plane_type_a from './ic_plane_type_a.png';
import ic_plane_type_b from './ic_plane_type_b.png';
// import ic_plane_type_c from './ic_plane_type_c.png';
// Green buildings
import ic_green_church from './ic_green_church.png';
import ic_green_hospital from './ic_green_hospital.png';
import ic_green_school from './ic_green_school.png';
// Explosion
import ic_explosion_1 from './ic_explosion_1.png';
import ic_explosion_2 from './ic_explosion_2.png';
import ic_explosion_3 from './ic_explosion_3.png';
// Drop
import ic_drop_1 from './ic_drop_1.png';
import ic_drop_2 from './ic_drop_2.png';
import ic_drop_3 from './ic_drop_3.png';

const images = {
  // Roofs
  ic_floor_roof_type_a,
  ic_floor_roof_type_b,
  ic_floor_roof_type_c,
  ic_floor_roof_type_d,
  ic_floor_roof_type_e,
  ic_floor_roof_type_f,
  ic_floor_roof_type_g,
  ic_floor_roof_type_h,
  ic_floor_roof_type_i,
  // Floors
  ic_floor_type_a,
  ic_floor_type_b,
  ic_floor_type_c,
  ic_floor_type_d,
  // Basements
  ic_floor_basement_type_a,
  ic_floor_basement_type_b,
  ic_floor_basement_type_c,
  ic_floor_basement_type_d,
  ic_floor_basement_type_e,
  // Plane
  // ic_plane_type_a,
  ic_plane_type_b,
  // ic_plane_type_c,
  // Green buildings
  ic_green_church,
  ic_green_hospital,
  ic_green_school,
  // Explosion
  ic_explosion_1,
  ic_explosion_2,
  ic_explosion_3,
  // Drops
  ic_drop_1,
  ic_drop_2,
  ic_drop_3,
};

export default images;